import { SummaryData } from 'hooks/queries/useMetricsSummary'
import Styles from './Summary.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { Skeleton } from 'antd'

interface SummaryItemProps {
  name: string
  data: SummaryData
  icon: React.ReactNode
  isFetching?: boolean
  showChange?: boolean
  type?: 'percent' | 'absolute'
  valueFormatter?: (value: number) => number | string | null
}

const percentChange = (num1: number | null, num2: number | null) => {
  if (num1 === null || num2 === null) return null
  if (num2 === 0) return Infinity

  return Math.round(((num1 - num2) / num2) * 100)
}

export const SummaryItem = ({
  name,
  data,
  icon,
  isFetching,
  showChange = true,
  type = 'absolute',
  valueFormatter = (value) => value,
}: SummaryItemProps) => {
  const change = percentChange(data.current_period, data.previous_period)

  return (
    <div className={Styles.summaryItem}>
      <div className={Styles.content}>
        {icon}
        <div className={Styles.details}>
          {isFetching ? (
            <div>
              <Skeleton paragraph={false} className={Styles.skeleton} />
            </div>
          ) : (
            <div className={Styles.valueAndChange}>
              <span className={Styles.value}>
                {data.current_period && valueFormatter(data.current_period)}
                {type === 'percent' && '%'}
              </span>
              {change !== null && change !== Infinity && !Number.isNaN(change) && showChange && (
                <span
                  className={cx(Styles.change, {
                    [Styles.positive]: change > 0,
                    [Styles.negative]: change < 0,
                  })}
                >
                  {change > 0 && '+'}
                  {change.toFixed(0)}%
                </span>
              )}
            </div>
          )}
          <Text variant="secondary" color="var(--dark-80)">
            {name}
          </Text>
        </div>
      </div>
    </div>
  )
}
